import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import PersonIcon from 'material-ui-icons/Person';

import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";

const sleep = ms => new Promise(res => setTimeout(res, ms));

class Profiles extends Component {

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };

  onProfilesMobile = (url) => {

    window.location.href = url;
  }

  onProfiles = (url) => {

    window.open(url);
  }

  /*
      if (window.location.href.includes('open_profile')){
        let profile_url = this.props.data["profile url"];
        this.props.changeRoute('/console/user/'+this.props.data["access id"])
        window.location.href = profile_url;
      }*/
  /*

  async onDid() {



    if (window.location.href.includes('open_profile')){

      let profile_url = this.props.data["profile url"];
      const {cookies}  = this.props;
      let date = new Date();
      date.setTime(date.getTime()+(7*24*60*60*1000));

      var winNav = window.navigator;
      var isIOSChrome = winNav.userAgent.match("CriOS");

      if (cookies.get('url_opened')) {
        if (cookies.get('url_opened') != profile_url){

          // If Cookies exist and URL has NOT been opened, lets take him there.
          cookies.set('url_opened', profile_url, { path: '/', expires: date });
          this.props.changeRoute('/console/user/'+this.props.data["access id"])
        //  alert("Push to Candidate Folders")
          window.history.replaceState(null, null, '/console/user/'+this.props.data["access id"]);
          window.history.pushState(null, null,'/console/user/'+this.props.data["access id"])
          //window.location.href = 'https://dsn-app.firebaseapp.com/console/user/'+this.props.data["access id"]+=

          if (isIOSChrome) {
             // is Google Chrome on IOS
             var r = window.confirm("Tap yes to go to the users candidate folder.");
            if (r == true) {
              window.location.href = profile_url;
            }
             //alert("Please wait while we take you to the candidates profile.")
             //window.location.href = profile_url;
          } else {
            window.location.href = profile_url;
          }

        } else {

           // If cookies exists but URL has already been inside, lets do nothing
           cookies.set('url_opened', "", { path: '/', expires: date });
        }
      } else {
        // If no cookies exist, then we should take it to the profile
        cookies.set('url_opened', profile_url, { path: '/', expires: date });
        this.props.changeRoute('/console/user/'+this.props.data["access id"])
        //alert("Push to Candidate Folders")
        window.history.replaceState(null, null, '/console/user/'+this.props.data["access id"]);
        window.history.pushState(null,null,'/console/user/'+this.props.data["access id"])
        //window.location.href = 'https://dsn-app.firebaseapp.com/console/user/'+this.props.data["access id"]
        if (isIOSChrome) {
           // is Google Chrome on IOS
           //alert("Please wait while we take you to the candidates profile.")
           //window.location.href = profile_url;
           var r = window.confirm("Tap yes to go to the users candidate folder.");
          if (r == true) {
            window.location.href = profile_url;
          }
        } else {
          window.location.href = profile_url;
        }
      }

    }
  }*/

  render(){
    const { classes, theme, location, data } = this.props;

    let profile_url = data["profile url"];

    if (isBrowser){
      return(
        <Button raised color="primary" onClick={() => this.onProfiles(profile_url)}>
          <PersonIcon className={classes.rightIcon} />
        </Button>
      );
    }

    if (isMobile){
      //this.onDid();
      return(
        <Button raised color="primary" onClick={() => this.onProfilesMobile(profile_url)}>
          <PersonIcon className={classes.rightIcon} />
        </Button>
      );
    }

    return(
      <div>
        <BrowserView>
          <Button raised color="primary" onClick={() => this.onProfiles(profile_url)}>
            <PersonIcon className={classes.rightIcon} />
          </Button>
        </BrowserView>
        <MobileView>
          <Button raised color="primary" onClick={() => this.onProfilesMobile(profile_url)}>
            <PersonIcon className={classes.rightIcon} />
          </Button>
        </MobileView>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        counter: state.counter,
        router: state.router,
        priority: state.dashboard.priority,
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}
/*
return(
  <div>
    <Dialog className={classes.root} open={this.props.overlayOpen} onRequestClose={() => this.props.closeOverlay()}>
      <DialogTitle>Delete this candidate?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Tap ok to open the candidate profile.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={() => this.props.closeOverlay()}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  </div>
);
*/

export default withCookies(withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps,mapDispatchToProps)(Profiles))));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/User/scenes/Core/components/Profiles/index.js